import { CartGetItem } from '../../../types';

type Args = {
  cartItems: CartGetItem[];
  cartId: string;
};

export const sendCartToLowes = ({ cartItems, cartId }: Args) => {
  let cartUrl = '';
  const items = [];

  for (let i = 0; i < cartItems.length; i++) {
    items.push(
      `productId_${i + 1}=${cartItems[i]['asin' as keyof CartGetItem]}`,
    );

    items.push(`quantity_${i + 1}=${cartItems[i].quantity}`);
  }

  const addToCartLink = `https://www.lowes.com/cart/add-ext?`;

  let itemParams = '';

  if (items.length) {
    itemParams += items.join('&');
  }

  // append offers and items to the cart URL if we don't chunk the cart above
  cartUrl = encodeURIComponent(addToCartLink + `${itemParams}`);

  return cartUrl;
};
